import { render, staticRenderFns } from "./tag-view.vue?vue&type=template&id=996c3c2a&scoped=true"
import script from "./tag-view.vue?vue&type=script&lang=js"
export * from "./tag-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996c3c2a",
  null
  
)

export default component.exports